import React from 'react'
import {
  ReferenceInput,
  required,
  ReferenceArrayInput,
  AutocompleteInput,
  AutocompleteArrayInput
} from 'react-admin';
import _propTypes from 'prop-types'
import _Introspecter from '@api-platform/admin/lib/InputGuesser'

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const IntrospectedInputGuesser = ({
  fields,
  readableFields,
  writableFields,
  schema,
  schemaAnalyzer,
  ...props
}) => {
  const field = fields.find(({
    name
  }) => name === props.source);

  if (!field) {
    console.error(`Field ${props.source} not present inside API description for the resource ${props.resource}`);
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }

  const validate = !props.validate && field.required ? [(0, required)()] : props.validate;

  const searchKey = props.searchKey || 'id'
  const searchFn = searchText => ({ [searchKey]: searchText })
  if (null !== field.reference) {
    if (1 === field.maxCardinality) {
      return (
        <ReferenceInput
          key={field.name}
          label={field.name}
          reference={field.reference.name}
          source={field.name}
          validate={validate}
          filterToQuery={searchFn}
          {...props}
          allowEmpty>
          <AutocompleteInput optionText={props.optionText || schemaAnalyzer.getFieldNameFromSchema(field.reference)}/>
        </ReferenceInput>
      );
    }
    return (
      <ReferenceArrayInput
        key={field.name}
        label={field.name}
        reference={field.reference.name}
        source={field.name}
        validate={validate}
        filterToQuery={searchFn}
        {...props}
        allowEmpty>
        <AutocompleteArrayInput optionText={props.optionText || schemaAnalyzer.getFieldNameFromSchema(field.reference)} />
      </ReferenceArrayInput>
    );
  }
  return _Introspecter({
    fields,
    readableFields,
    writableFields,
    schema,
    schemaAnalyzer,
    ...props
  })
}

const InputGuesser = props => /*#__PURE__*/React.createElement(_Introspecter, _extends({
  component: IntrospectedInputGuesser,
  includeDeprecated: true
}, props));

InputGuesser.propTypes = {
  source: _propTypes.string.isRequired
};

export default InputGuesser
